__turbopack_context__.v({
  "acf-travel-specialist-promo": "HvvUWq_acf-travel-specialist-promo",
  "acf-travel-specialist-promo__buttons": "HvvUWq_acf-travel-specialist-promo__buttons",
  "acf-travel-specialist-promo__container": "HvvUWq_acf-travel-specialist-promo__container",
  "acf-travel-specialist-promo__content": "HvvUWq_acf-travel-specialist-promo__content",
  "acf-travel-specialist-promo__image": "HvvUWq_acf-travel-specialist-promo__image",
});
